import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=acc44bae&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc44bae",
  null
  
)

export default component.exports